export default __webpack_public_path__ + "static/media/MODO.e2fc9921.pdf";